import { IIncident } from 'types/VehicleIncidents';

type CheckboxOption = { checked?: boolean; is_selected?: boolean };
type PersonInvolved = {
	personInvolved_name?: string;
	personInvolved_phone_number?: string;
};
type Witness = { witness_name?: string; witness_phone_number?: string };
type ThirdParty = {
	thirdParty_name?: string;
	thirdParty_vehicle_registration?: string;
	thirdParty_licence_number?: string;
	thirdParty_phone_number?: string;
};

const hasValue = (value: unknown) =>
	value !== null &&
	value !== undefined &&
	(typeof value !== 'string' || value.trim().length > 0);

const hasCheckedOption = (options?: CheckboxOption[]) =>
	!!options?.some((option) => option.checked || option.is_selected);

export const getIncompleteIncidentSections = (
	incident: IIncident['incidentData']
): string[] => {
	const incompleteSections: string[] = [];
	const section1 = incident.incident_section_1;
	const section2 = incident.incident_section_2;
	const section3 = incident.incident_section_3;
	const section4 = incident.incident_section_4;
	const section5 = incident.incident_section_5;
	const section7 = incident.incident_section_7;
	const injuries = !!section3?.injuries;

	if (
		!section1 ||
		[
			section1.incident_description,
			section1.location,
			section1.client_name,
			section1.job_details,
			section1.incident_date,
			section1.reported_date,
			section1.incident_time,
			section1.reported_time,
		].some((value) => !hasValue(value)) ||
		(section1.thirdParty &&
			(!section1.thirdParties?.length ||
				section1.thirdParties.some((party: ThirdParty) =>
					[
						party.thirdParty_name,
						party.thirdParty_vehicle_registration,
						party.thirdParty_licence_number,
						party.thirdParty_phone_number,
					].some((value) => !hasValue(value))
				)))
	) {
		incompleteSections.push('1. Description');
	}

	if (
		(section2?.personInvolved?.length &&
			section2.personInvolved.some((person: PersonInvolved) =>
				[person.personInvolved_name, person.personInvolved_phone_number].some(
					(value) => !hasValue(value)
				)
			)) ||
		(section2?.witness_exists &&
			(!section2.witnesses?.length ||
				section2.witnesses.some((witness: Witness) =>
					[witness.witness_name, witness.witness_phone_number].some(
						(value) => !hasValue(value)
					)
				)))
	) {
		incompleteSections.push('2. Person Involved');
	}

	if (
		injuries &&
		(!hasCheckedOption(section3?.body_injured) ||
			!hasCheckedOption(section3?.injury_type) ||
			!hasCheckedOption(section3?.incident_mechanism) ||
			!hasCheckedOption(section3?.incident_agency))
	) {
		incompleteSections.push('3. Injury');
	}

	if (
		!section4 ||
		!hasCheckedOption(section4.incident_category) ||
		(section4.notifiable_incident &&
			(!hasValue(section4.reported_to) ||
				!hasValue(section4.reference_number))) ||
		(section4.life_saving_rule_breach &&
			!hasCheckedOption(section4.life_saving_rules)) ||
		(section4.code_of_conduct_breach &&
			!hasCheckedOption(section4.code_of_conduct)) ||
		(!injuries &&
			(!hasCheckedOption(section4.incident_mechanism) ||
				!hasCheckedOption(section4.incident_agency)))
	) {
		incompleteSections.push('4. Analysis');
	}

	if (
		!hasValue(section5?.shift_start_time) ||
		(section5?.incident_investigation_required &&
			!hasValue(section5.investigator))
	) {
		incompleteSections.push('5. Investigation');
	}

	if (section7?.actions?.some((action) => !action.completed)) {
		incompleteSections.push('7. Corrective Actions');
	}

	return incompleteSections;
};
